<template>
    <loading-spinner v-if="isLoading"></loading-spinner>
    <div v-else>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">공지사항</span>
            <span class="txt">센터 admin에 보여질 공지사항을 작성 할 수 있습니다.</span>
        </div>
        <loading-spinner v-if="!noticeDetail"></loading-spinner>
        <div v-else class="com-table-content">
            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/notice/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/notice/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deleteNotice(noticeDetail.id)">
                        삭제
                    </button>
                    <!--                    <button v-else class="com-btn red" @click="deleteNotice(noticeDetail.centerBoardNoticeId)">삭제</button>-->
                </div>
            </div>
            <table class="com-table view">
                <colgroup>
                    <col style="width: 170px" />
                    <col style="width: auto" />
                    <col style="width: 170px" />
                    <col style="width: auto" />
                </colgroup>
                <tbody>
                    <tr>
                        <th>카테고리</th>
                        <td>{{ noticeDetail.boardCategory === null ? '' : noticeDetail.boardCategory.name }}</td>
                        <th>글쓴이</th>
                        <td>{{ noticeDetail.staffName ? noticeDetail.staffName : '핏투데이케어' }}</td>
                    </tr>
                    <tr>
                        <th>노출대상</th>
                        <td v-html="showType"></td>
                        <th>조회수</th>
                        <td>{{ noticeDetail.viewCount }}</td>
                    </tr>
                    <tr>
                        <th>첨부파일</th>
                        <td>
                            <a
                                v-for="(file, index) in fileList"
                                :key="index"
                                :href="file.fileUrl"
                                class="file-down"
                                style="cursor: pointer"
                            >
                                {{ file.name }}
                            </a>
                        </td>
                        <th>등록일</th>
                        <td>{{ noticeDetail.info.createdAt | timestampFilter }}</td>
                    </tr>
                    <tr>
                        <th>제목</th>
                        <td colspan="3">{{ noticeDetail.title }}</td>
                    </tr>
                    <tr>
                        <td class="no-padding no-side-border" colspan="4">
                            <div class="txt-view">
                                <div class="ck-content" v-html="noticeDetail.content"></div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="com-btn-area">
                <div class="right-box">
                    <router-link class="com-btn gray" to="/madmin/notice/list">목록</router-link>
                    <router-link v-if="careAuth === true" :to="`/madmin/notice/edit/${id}`" class="com-btn blue">
                        수정
                    </router-link>
                    <button v-if="careAuth === true" class="com-btn red" @click="deleteNotice(noticeDetail.id)">
                        삭제
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';

export default {
    name: 'noticeDetail',
    components: { LoadingSpinner },
    props: {},
    computed: {
        isCareAdmin() {
            return this.$store.getters['auth/isCareAdmin'];
        },
        isSystemAdmin() {
            return this.$store.getters['auth/isSystemAdmin'];
        },
    },
    mounted() {
        if (this.isCareAdmin || this.isSystemAdmin) {
            // 케어 권한 확인
            this.careAuth = true;
        }
        this.fetchNoticeDetail();
    },
    data() {
        return {
            careAuth: false,
            isLoading: false,
            id: this.$route.params.id,
            noticeDetail: null,
            showTypeList: [
                '전체 <small>(관리자 PC, 관리자 APP, 회원 APP 공지사항에 노출됩니다.)</small>',
                '관리자 <small>(관리자 PC, 관리자 APP 공지사항에 노출됩니다.)</small>',
                '회원 <small>(회원 APP 공지사항에 노출됩니다.)</small>',
            ], // 노출대상
            showTypeValueList: ['T', 'A', 'C'], // 노출대상 Value 목록
            fileList: null,
            showType: '',
        };
    },
    methods: {
        // 공지사항 상세 Fetch
        async fetchNoticeDetail() {
            try {
                const { data } = await this.getNoticeDetail(this.id);
                console.log(data);
                this.noticeDetail = data;

                if (data.fileGroupId) {
                    // fileGroupId가 있으면 파일 목록 fetch
                    const fileGroupData = await this.getNoticeDetailFileGroup(data.fileGroupId);
                    this.fileList = fileGroupData.data;
                }

                this.showTypeValueList.forEach((showType, index) => {
                    // 노출대상 찾기
                    if (showType === this.noticeDetail.showType) {
                        this.showType = this.showTypeList[index];
                    }
                });

                console.log('===> Success Loading Notice Detail', data);
            } catch (error) {
                console.log(error);
            }
        },

        // 공지사항 삭제
        async deleteNotice(id) {
            try {
                this.isLoading = true;
                const { data } = await this.getDeleteNotice(id);
                alert('공지사항을 삭제했습니다.');
                this.isLoading = false;
                console.log('===> Success Delete Notice', data);
                this.$router.push({ name: 'noticeList' });
            } catch (error) {
                console.log(error);
            }
        },

        // 공지사항 상세 API
        getNoticeDetail(id) {
            // 스웨거 검색: FT공지사항 게시글 확인
            return api.get(`/admin/api/ft/board/notice/${id}/view`);
        },

        // 공지사항 상세 첨부 파일 리스트 API
        getNoticeDetailFileGroup(fileGroupId) {
            return api.get(`/admin/api/board/file-group/${fileGroupId}`);
        },

        // 공지사항 삭제 API
        getDeleteNotice(id) {
            return api.delete(`/admin/api/ft/board/notice/${id}`);
        },

        // a 태그 파일 다운로드 이벤트
        fileDownload(url) {
            api.post(url, {
                responseType: 'blob',
            })
                .then(function (response) {
                    let blob = new Blob([response.data], { type: 'image/png' });

                    let link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    const filename = replaceAll(decodeURI(response.headers.filename), '+', ' ');
                    link.setAttribute('download', filename);
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
<style scoped src="@/assets/js/ckeditor/ckeditor.css"></style>
<!-- ckeditor5 css -->
<style lang="scss" scoped>
a.file-down::after {
    content: ',' attr(file-down);
    margin-right: 5px;
}

a.file-down:last-of-type::after {
    content: '';
}
</style>
